import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LeftSide from "../app/public-layout/left-side";
import ResetPasswordForm from "./reset-password-form";
const ResetPassword = () => {
    return (_jsx(LeftSide, Object.assign({ title: "Reset password", subtitle: "A link will be emailed to you to create a new password." }, { children: _jsx(ResetPasswordForm, {}) })));
};
export default ResetPassword;
